// Write your code here
import {Chrono} from 'react-chrono'
import CourseTimelineCard from '../CourseTimelineCard'
import ProjectTimelineCard from '../ProjectTimelineCard'

const TimelineView = props => {
  const {timelineItemsList} = props
  const items = timelineItemsList.map(timelineItems => ({
    title: timelineItems.title,
  }))

  return (
    <div
      className={`
      w-95% max-w-[1200px]
    `}
    >
      <h1>MY JOURNEY OF CCBP 4.0</h1>
      <Chrono
        items={items}
        mode="VERTICAL_ALTERNATING"
        slideItemDuration={5000}
        slideShow
      >
        {timelineItemsList.map(timelineItems =>
          timelineItems.categoryId === 'PROJECT' ? (
            <ProjectTimelineCard {...timelineItems} key={timelineItems.id} />
          ) : (
            <CourseTimelineCard {...timelineItems} key={timelineItems.id} />
          ),
        )}
      </Chrono>
    </div>
  )
}

export default TimelineView
